/**
 * 全局狀態
 */
import React from 'react';
import type { FormInstance } from 'antd';

const StepContext = React.createContext<{
  // 是否完成身份識別
  isAuth: boolean;
  // 申請表單實例
  formRenderInstance: FormInstance | null;
  // 支付組件實例
  moPayRef;
  // 是否完成支付
  isPayed: boolean;
  // 身份識別組件實例
  identityRef;
}>({
  isAuth: false,
  formRenderInstance: null,
  moPayRef: null,
  isPayed: false,
  identityRef: null,
});

export default StepContext;
